import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import WaitWhileBusy from '../WaitWhileBusy';
import { ClearEnrichmentsCache } from '../loaders/LoadEnrichments';
import LoadEvent from '../loaders/LoadEvent';
import LoadEventLiveVoting from '../loaders/LoadEventLiveVoting';
import EventHomeScreen from '../screens/EventHomeScreen/EventHomeScreen';
import SubEventHomeScreen from '../screens/EventHomeScreen/SubEventHomeScreen';
import EventInfo from '../screens/EventInfo/EventInfo';
import EventNewsDetails from '../screens/EventNewsDetails/EventNewsDetails';
import EventQRCode from '../screens/EventQRCode';
import EventSponsorMessage from '../screens/EventSponsorMessage';
import EventMeetingLocations from '../screens/MeetingLocations/EventMeetingLocations';
import EventUserAvailability from '../screens/Meetings/EventUserAvailability';
import InviteToMeetingScreen from '../screens/Meetings/InviteToMeetingScreen';
import ErrorBoundary from '../validate/ErrorBoundary';
import HasEvent from '../validate/HasEvent';
import Validate from '../validate/Validate';
import EventRouteOverrider from './EventRouteOverrider';
import agendaRoutes from './agendaRoutes';
import chatRoutes from './chatRoutes';
import directoryRoutes from './directoryRoutes';
import enrichmentRoutes from './enrichmentRoutes';
import eventNotificationRoutes from './eventNotificationRoutes';
import exhibitorRoutes from './exhibitorRoutes';
import formRoutes from './formRoutes';
import liveVotingRoutes from './liveVotingRoutes';
import mapRoutes from './mapRoutes';
import meetingRoutes from './meetingRoutes';
import participantsRoutes from './participantsRoutes';
import qaRoutes from './qaRoutes';
import scheduleRoutes from './scheduleRoutes';
import speakersRoutes from './speakersRoutes';
import startNetworkingRoutes from './startNetworkingRoutes';
import { leadsRoutes } from './leadsRoutes';
import { EventMapRedirector } from '../screens/EventMap/EventMapRedirector';

export const EventRoutes = (props) => {
    return (
        <Switch>
            {/* Community specific routes */}
            <Route path="/events/:communityId/agenda" component={agendaRoutes} />
            <Route path="/events/:communityId/subevent/:eventId" exact component={SubEventHomeScreen} />

            {/* Common event routes */}
            <Route path={`${props.match.path}/livevoting`} component={liveVotingRoutes} />
            <Route path={`${props.match.path}/availability/:date?`} exact component={EventUserAvailability} />
            <Route path={`${props.match.path}/chats`} component={chatRoutes} />
            <Route path={`${props.match.path}/content/:path+`} exact component={directoryRoutes} />
            <Redirect from={`${props.match.path}/directory`} to={`${props.match.path}`} exact />
            <Route path={`${props.match.path}/directory/:path+`} component={directoryRoutes} />
            <Route path={`${props.match.path}/enrich`} component={enrichmentRoutes} />
            <Route path={`${props.match.path}/exhibitors`} component={exhibitorRoutes} />
            <Route path={`${props.match.path}/info`} exact component={EventInfo} />
            <Route path={`${props.match.path}/invite`} exact component={InviteToMeetingScreen} />
            <Route path={`${props.match.path}/locations`} exact component={EventMeetingLocations} />
            <Route path={`${props.match.path}/map`} component={mapRoutes} />
            <Route path={`${props.match.path}/maps`} component={EventMapRedirector} />
            <Route path={`${props.match.path}/meetings`} component={meetingRoutes} />
            <Route path={`${props.match.path}/news/:articleId`} exact component={EventNewsDetails} />
            <Route path={`${props.match.path}/participants`} component={participantsRoutes} />
            <Route path={`${props.match.path}/qa`} component={qaRoutes} />
            <Route path={`${props.match.path}/qr_code`} exact component={EventQRCode} />
            <Route path={`${props.match.path}/schedule`} component={scheduleRoutes} />
            <Route path={`${props.match.path}/speakers`} component={speakersRoutes} />
            <Route path={`${props.match.path}/sponsor/:sponsorId/message`} exact component={EventSponsorMessage} />
            <Route path={`${props.match.path}/sponsor/:path+`} component={directoryRoutes} />
            <Route path={`${props.match.path}/forms`} component={formRoutes} />
            <Route path={`${props.match.path}/start-networking`} component={startNetworkingRoutes} />
            <Route path={`${props.match.path}/notifications`} component={eventNotificationRoutes} />
            <Route path={`${props.match.path}/leads`} component={leadsRoutes} />
            <Route path={`${props.match.path}`} exact component={EventHomeScreen} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    );
};

const EventRouter = (props) => {
    const { eventId } = useParams();
    useEffect(
        () => () => {
            // NOTE: I really don't like to have this in the router, since it isn't exactly route related but let it stay here for the moment...

            // Prevents the user from instantly joining the set virtualRoom url when opening the same event.
            console.log(`Clean up virtual room upon unmounting eventRoutes, eventId:${props.match.params.eventId}`);
            app.store.dispatch(app.actions.ui.sidePanel.reset());
        },
        [eventId]
    );

    return (
        <ErrorBoundary altRoute="..">
            <Validate
                validate={(state) => {
                    if (!parseInt(props.match.params.eventId)) {
                        throw new Error(`Invalid event identification: ${props.match.params.eventId}`);
                    }
                }}
                onError={(err) => {
                    console.warn(err);
                    app.history.replace('/');
                }}
                key={props.match.params.eventId}>
                <WaitWhileBusy>
                    <HasEvent eventId={props.match.params.eventId}>
                        <LoadEvent eventId={props.match.params.eventId}>
                            <LoadEventLiveVoting eventId={props.match.params.eventId}>
                                <ClearEnrichmentsCache eventId={props.match.params.eventId}>
                                    <EventRouteOverrider {...props}>
                                        <EventRoutes {...props} />
                                    </EventRouteOverrider>
                                </ClearEnrichmentsCache>
                            </LoadEventLiveVoting>
                        </LoadEvent>
                    </HasEvent>
                </WaitWhileBusy>
            </Validate>
        </ErrorBoundary>
    );
};

export default EventRouter;
